import { Component, EventEmitter, Input, Output } from '@angular/core';
import { PermissionsService } from 'src/app/services/permissions.service';
import { ICerere } from '../../cereri.interface';

@Component({
    selector: 'actiuni-cerere-card',
    templateUrl: './actiuni-cerere-card.component.html',
    styleUrls: ['./actiuni-cerere-card.component.scss'],
})
export class ActiuniCerereCardComponent {
    @Input() title!: string;
    @Input() description!: string;
    @Input() iconName!: string;
    @Input() btnColor: string = 'warn';
    @Input() actionText!: string;
    @Input() actionType!: string;
    @Input() iconColor?: string = 'red';
    @Input() isSelected?: boolean = false;
    @Input() cerere?: ICerere;
    @Output() buttonClicked = new EventEmitter<string>();
    @Output() buttonResetClicked = new EventEmitter<string>();

    onButtonClick() {
        this.buttonClicked.emit(this.actionType);
    }

    onButtonResetClick() {
        this.buttonResetClicked.emit(this.actionType);
    }

    toggleSelected() {
        this.isSelected = !this.isSelected;
    }

    constructor(
        public permissionsService: PermissionsService
    ) { }

    selectedClass() {
        switch (this.actionType) {
            case 'validate':
                return this.cerere?.validated_date !== null ? true : false;
            case 'invalidate':
            case 'anulare': // clasare
                return this.cerere?.cancel_date !== null ? true : false;
            case 'finalizare':
                return this.cerere?.registratura?.finalize_date !== null ? true : false;
            default:
                return false;
        }
    }
}
